// axiosInt.js
import axios from "axios";
import { defaultConfig } from "../config";
import { removeAuth } from "../components/common/Helper";
import { showError } from "../utils/messageEvents";

const axiosInt = axios.create({
  baseURL: defaultConfig.baseAPIUrl,
});

axiosInt.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error?.response?.status;
    const message = error?.response?.data?.message || error?.message || "An error occurred";
    error.message = message;

    switch (status) {
      case 400:
      case 304:
      case 429:
      case 403:
      case 404:
      case 409:
      case 410:
      case 500:
      case 502:
      case 503:
      case 504:
        showError(message);
        break;

      case 401:
        removeAuth();
        localStorage.removeItem("adminToken");
        localStorage.removeItem("adminData");
        showError(message || "Session expired. Please login again.");
        window.location.href = "/";
        break;

      default:
        showError(message);
    }

    return Promise.reject(error);
  }
);

export default axiosInt;